/* eslint-disable no-unused-vars */
import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { logedOut } from "~/actions/auth.action";
// import {initializeProject} from 'ProjectMg/actions/project.action';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";

// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
import Dashboard from "@material-ui/icons/Dashboard";
import Search from "@material-ui/icons/Search";
// core components
import CustomInput from "../../components/CustomInput/CustomInput.js";
import Button from "../../components/CustomButtons/Button.js";

import I18nMenu from '../../i18n/NavMenu';
import styles from "../../assets/jss/material-dashboard-react/components/rtlHeaderLinksStyle.js";
import { Menu } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ThemeLightning from "../ThemeLightning";

const useStyles = makeStyles(styles);

function RTLNavbarLinks(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(null);
  const [notificationNumber, setNotificationNumber] = React.useState(1);
  const [openProfile, setOpenProfile] = React.useState(null);
  const history = useHistory();
  React.useEffect(() => {
    window.addEventListener('focus', () => {
      // console.log('Tab is in focus');
    });
    window.addEventListener('blur', () => {
      // console.log('Tab is blurred');
    });
    window.onbeforeunload = confirmExit;
    function confirmExit() {
      // props.logOut(props._id);
    }
  }, [history]);

  const handleToggle = (event) => {
    if (open && open.contains(event.target)) {
      setOpen(null);
    } else {
      setOpen(event.currentTarget);
    }
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      console.log(Boolean(event.currentTarget));
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };

  return (
    <div>
      <div className={classes.searchWrapper}>
        <CustomInput
          formControlProps={{
            className: classes.margin + " " + classes.search,
          }}
          inputProps={{
            placeholder: "Search...",
            inputProps: {
              "aria-label": "Search",
            },
          }}
        />
        <Button color="white" aria-label="edit" justIcon round>
          <Search />
        </Button>
      </div>
      <I18nMenu />
      <ThemeLightning />
      {process.env.NODE_ENV === 'development' && <Button
        color={window.innerWidth > 959 ? "transparent" : "white"}
        justIcon={window.innerWidth > 959}
        simple={!(window.innerWidth > 959)}
        aria-label="Dashboard"
        className={classes.buttonLink}
      >
        <Dashboard className={classes.icons} />
        <Hidden mdUp implementation="css">
          <p className={classes.linkText}>Dash</p>
        </Hidden>
      </Button>}
      <div className={classes.manager}>
        <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={open ? "menu-list-grow" : null}
          aria-haspopup="true"
          onClick={handleToggle}
          className={classes.buttonLink}
        >
          <Notifications className={classes.icons} />
          <span className={classes.notifications}>{props.bellTask.length}</span>
          <Hidden mdUp implementation="css">
            <p onClick={handleToggle} className={classes.linkText}>
              Notification
            </p>
          </Hidden>
        </Button>
        <Menu
          anchorEl={open}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          keepMounted
          open={Boolean(open)}
          onClose={handleClose}
          TransitionComponent={Grow}
        >
          {props.bellTask?.map((project) => (
            <MenuItem
              key={project.projectTitle}
              onClick={handleClose}
              className={classes.dropdownItem}
            >
              {project.projectTitle}
            </MenuItem>
          ))}
        </Menu>
      </div>
      <Button
        color={window.innerWidth > 959 ? "transparent" : "white"}
        justIcon={window.innerWidth > 959}
        simple={!(window.innerWidth > 959)}
        aria-label="Person"
        onClick={handleClickProfile}
        className={classes.buttonLink}
      >
        <Person className={classes.icons} />
        <Hidden mdUp implementation="css">
          <p className={classes.linkText}>personal profile</p>
        </Hidden>
      </Button>
      <Menu
        anchorEl={openProfile}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        keepMounted
        open={Boolean(openProfile)}
        onClose={handleCloseProfile}
        TransitionComponent={Grow}
      >
        <MenuItem
          onClick={() => {
            history.push("/admin/user")
          }}
          className={classes.dropdownItem}
        >
          profile
        </MenuItem>
        <MenuItem
          onClick={() => {
            history.push("/admin/user")
          }} 
          className={classes.dropdownItem}
        >
          setting
        </MenuItem>
        <Divider light />
        <MenuItem
          onClick={() => {
            props.logOut(props._id);
            history.push("/login")
            // props.initializeProject();
          }}
          className={classes.dropdownItem}
        >
          log out
        </MenuItem>
      </Menu>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    bellTask: state.bellReducer.task,
    isAuthenticated: state.authReducer.isAuthenticated,
    _id: state.authReducer.user._id,
    authError: state.authReducer.authError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logOut: (_id) => dispatch(logedOut(_id)),
    // initializeProject:() => dispatch(initializeProject()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RTLNavbarLinks);
